import React, { Component } from "react";
import InputMask from 'react-input-mask';
import { getPhoneFormat, hasRole, getSum } from "../../helper/helperFunctions";


const PhoneFormat = getPhoneFormat('uk');
class CustomPhoneNumber extends Component {

	constructor(props) {
		super(props);
		this.state = {
			validatorArrayFrance : [
				{
					'regex': [/^[\d]{2}[-]?[\d]{1}[-]?[\d]{2}[-]?[\d]{2}[-]?[\d]{2}[-]?[\d]{2}$/]
				},
			],
            validatorArrayOthers : [
				{
					'regex': [/^[\d]{3}[-]?[\d]{3}[-]?[\d]{4}[-]?[\d]{0,6}$/]
				},
			]
		}

	}
	componentDidMount() {
        const { required, fieldIndex } = this.props;

        if (required) {
            this.setState({
                validatorArrayOthers: [
                'required',
                {
                    regex: [/^[\d]{3}[-]?[\d]{3}[-]?[\d]{4}[-]?[\d]{0,6}$/],
                    message: 'The wed party contact cell phone format is invalid.'
                }
                ],
                validatorArrayFrance: [
                'required',
                {
                    regex: [/^[\d]{2}[-]?[\d]{1}[-]?[\d]{2}[-]?[\d]{2}[-]?[\d]{2}[-]?[\d]{2}$/],
                    message: 'The wed party contact cell phone format is invalid (France).'
                }
                ],
                customRequiredMessage: `The wed party contact phone ${fieldIndex} field is required.`
            });
        }
    }

	render(){
		const { validatorArrayOthers, validatorArrayFrance, customRequiredMessage  } = this.state;
		const { name, value, validationName, pa_initial_country_France, sa_initial_country_France, agency_pa_is_france, agency_sa_is_france,
            vsa_initial_country_France,
            ptma_initial_country_France,
            ptma_is_france,
            vsa_is_france,
            frontend_order_is_France,
            account_agency_is_france } = this.props;

        let mask = PhoneFormat[1];
        let placeHolder = PhoneFormat[2];

        let is_agency_france = false;
        let is_order_france = false;

        is_order_france = vsa_initial_country_France || ptma_initial_country_France || ptma_is_france || vsa_is_france
        is_agency_france = pa_initial_country_France || sa_initial_country_France || agency_pa_is_france || agency_sa_is_france
		return(
            <div>
                {
                    is_agency_france || is_order_france || frontend_order_is_France || account_agency_is_france

                        ?
                            <React.Fragment>
                                <InputMask
                                    mask={"99-9-99-99-99-99"}
                                    maskChar={null}
                                    id={this.props.elemId}
                                    type="text"
                                    name={name}
                                    className="form-control phone_icon"
                                    placeholder="12-3-45-67-89-10"
                                    value={value}
                                    onChange={this.props.handleParent}
                                    onClick={this.props.handleParent}
                                />
                                <div style={{width: '100%'}}>
                                    {
                                        this.props.validator &&
                                            this.props.validator.message(validationName, value, validatorArrayFrance,
                                                { messages: { required: customRequiredMessage } })
                                    }
                                </div>
                            </React.Fragment>
                        :
                            <React.Fragment>
                                <InputMask
                                    mask={hasRole(['gm admin']) ? mask : "999-999-9999-999999"}
                                    maskChar={null}
                                    id={this.props.elemId}
                                    type="text"
                                    name={name}
                                    className="form-control phone_icon"
                                    placeholder={hasRole(['gm admin']) ? placeHolder : "123-456-7890-123456"}
                                    value={value}
                                    onChange={this.props.handleParent}
                                    onClick={this.props.handleParent}
                                />
                                <div style={{width: '100%'}}>
                                    {
                                        this.props.validator &&
                                            this.props.validator.message(validationName, value, validatorArrayOthers,
                                                    { messages: { required: customRequiredMessage } })
                                    }
                                </div>
                            </React.Fragment>
                }
            </div>
		);
	};
}



export default CustomPhoneNumber;
